// extracted by mini-css-extract-plugin
module.exports = {"washingRuleItem":"WashingRules_washingRuleItem__VMdZq","washingRuleDescription":"WashingRules_washingRuleDescription__7oCn_","icon":"WashingRules_icon__T2ZiT"};